module.exports = __webpack_public_path__ + "static/media/symbol-prepick_white.f84b239f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-prepick_white.svg
// module id = ./src/assets/images/symbol-prepick_white.svg
// module chunks = 0